import { render, staticRenderFns } from "./InvestigationSetup.vue?vue&type=template&id=02632c8e&scoped=true"
import script from "./InvestigationSetup.vue?vue&type=script&lang=js"
export * from "./InvestigationSetup.vue?vue&type=script&lang=js"
import style0 from "./InvestigationSetup.vue?vue&type=style&index=0&id=02632c8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02632c8e",
  null
  
)

export default component.exports